import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Login from "@/views/Login.vue";
import Problems from "@/views/Problems/Problems.vue";
import store from "../store";
import MainLayout from "@/views/MainLayout.vue";
import Dashboard from "@/views/Dashboard.vue";
import Shipments from "@/views/Shipments/Shipments.vue";
import MrnMawb from "@/views/MrnMawb.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "MainLayout",
    component: MainLayout,
    meta: { loggedIn: true },
    children: [
      {
        path: "/",
        name: "Home",
        component: Dashboard,
      },
      {
        path: "/problems",
        name: "Problems",
        component: Problems,
      },
      {
        path: "/shipments",
        name: "shipments",
        component: Shipments,
      },
      {
        path: "/mrn-mawb",
        name: "mrn-mawb",
        component: MrnMawb,
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  const requiresLogin = to.matched.some((route) => route.meta.loggedIn);

  if (requiresLogin && !store.state.loggedIn) {
    // Gebruiker is nog niet ingelogd:
    next({
      path: "/login",
      query: {
        next: to.path,
      },
    });
    return;
  }

  next();
});

export default router;
